import styles from './BottomNavegation.module.scss';
import React, { useContext, useState } from 'react';
import { Menu } from '../menu/Menu';
import { CartContext } from 'shared/contexts/Cart/CartContext';
import { useAuth } from "shared/contexts/Auth/AuthContext";
import { House, Heart, ShoppingCart, TextAlignJustify } from "lucide-react";
import { Link, useLocation, useNavigate } from 'react-router-dom';

export const Navegacao = () => {

  const [menuPop, setMenuPop] = useState<null | HTMLElement>(null);
  const { cartQtd } = useContext(CartContext);
  const { perfilAtivo } = useAuth();

  const navigate = useNavigate();
  const [isClosingMenu, setIsClosingMenu] = useState(false);
  const location = useLocation();

  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {

    if (menuPop) {
      handleCloseMenu();
    } else {
      setMenuPop(event.currentTarget);
    }

  };

  const handleCloseMenu = () => {

    if (isClosingMenu) return;

    setIsClosingMenu(true);

    setTimeout(() => {
      setIsClosingMenu(false);
      setMenuPop(null);
    }, 300);

  };

  return (
    <div className={styles.navWrapper}>
      <div className={styles.nav}>

        {/* Home */}
        <div  className={`${styles.containerNav} ${location.pathname === "/" ? styles.active : ""}`} onClick={() => navigate("/", {state: {
        resetCategoria: true,},})}>
        <House size={20} className={styles.iconNav}/>
        <p className={styles.pNav}>Home</p>
      </div>

        {/* Compras */}
        <div className={`${styles.containerNav} ${location.pathname === "/carrinho" ? styles.active : ""}`}>
          <Link to="/carrinho" className={styles.btnNav}>
            <ShoppingCart size={20} className={styles.iconNav}/>
            {cartQtd > 0 && (
              <span className={styles.qtdCompras}>{cartQtd}</span>
            )}
          </Link>
          <p className={styles.pNav}>Compras</p>
        </div>

        {/* Favoritos */}
        <div className={`${styles.containerNav} ${location.pathname === "/favoritos" ? styles.active : ""}`}>
          <Link to="/favoritos" className={styles.btnNav}>
            <Heart size={20} className={styles.iconNav}/>
          </Link>
          <p className={styles.pNav}>Favoritos</p>
        </div>

        {/* Menu */}
        <div className={`${styles.containerNav} ${menuPop ? styles.active : ""}`}>
          <button className={styles.btnNav} onClick={handleClickMenu}>
            <TextAlignJustify size={20} className={styles.iconNav}/>
          </button>
          <p className={styles.pNav}>Mais</p>
        </div>

        {/* BACKDROP */}
        {menuPop && (
          <div
            className={styles.overlay}
            onClick={handleCloseMenu}
          />
        )}

        {/* MENU */}
        {menuPop && (
          <div
            key={perfilAtivo}
            className={`${styles.menuOverlay} ${
              isClosingMenu ? styles.closing : ''
            }`}
          >
            <Menu handleClose={handleCloseMenu} />
          </div>
        )}

      </div>
    </div>
  );
};